import React, { useState } from 'react';
import { AcvtGenHeader } from '../generic-header';
import style from './style.module.scss';
import ArrowIcon from '../../../icons/left-arrow.svg?react';
import parser from 'html-react-parser';
import { AcvtGame, AcvtSupportedLanguages } from '../../../types/acvt';
import { useT, usePreview } from '../../preview';

type GameInfo = {
    /**
     * Kept for backward compatibility — strings come from `useT()` and
     * the active language from `usePreview()`.
     */
    language?: AcvtSupportedLanguages;
    gameObject?: AcvtGame;
    opened?: React.Dispatch<
        React.SetStateAction<{
            homePromoCard: boolean;
            homeGameCard: boolean;
            promoCard: boolean;
            gameCard: boolean;
        }>
    >;
};

export const AcvtGamePage = ({ gameObject, opened }: GameInfo) => {
    const t = useT();
    const { language } = usePreview();
    const [checkboxStatus, setCheckboxStatus] = useState(
        Array(gameObject?.checkboxes?.length).fill(false)
    );

    const [isIconHovering, setIsIconHovering] = useState(false);

    const handleMouseEnter = () => {
        setIsIconHovering(true);
    };

    const handleMouseLeave = () => {
        setIsIconHovering(false);
    };

    const buttonHandler = (index: number) => {
        const status = [...checkboxStatus];
        status[index as number] = !status[index as number];
        setCheckboxStatus(status);
    };

    return (
        <div className={style.game_wrapper}>
            <AcvtGenHeader>
                <ArrowIcon
                    style={{ cursor: 'pointer' }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    className={style.back_arrow}
                    onClick={() =>
                        opened?.((prevState) => {
                            return {
                                ...prevState,
                                gameCard: false,
                                homeGameCard: false,
                            };
                        })
                    }
                />
                {t.games.header}
            </AcvtGenHeader>
            <div className={style.game_content}>
                <div className={style.title}>
                    {gameObject?.title[language as AcvtSupportedLanguages]}
                </div>
                <div className={style.subtitle}>
                    {gameObject?.subTitle[language as AcvtSupportedLanguages]}
                </div>
                <div className={style.game_banner}>
                    <img
                        alt=""
                        src={
                            gameObject?.detailImage?.[language] ||
                            gameObject?.image?.[language] ||
                            ''
                        }
                    />
                </div>
                <div className={style.info_grid}>
                    <button
                        className={style.play_button}
                        disabled={
                            checkboxStatus.filter((status) => status === true)
                                .length === gameObject?.checkboxes?.length
                                ? false
                                : true
                        }
                    >
                        {gameObject?.buttonTitle[
                            language as AcvtSupportedLanguages
                        ] != null &&
                        gameObject?.buttonTitle[
                            language as AcvtSupportedLanguages
                        ] !== ''
                            ? gameObject?.buttonTitle[
                                  language as AcvtSupportedLanguages
                              ]
                            : t.games.playButton}
                    </button>

                    <div className={style.checkboxes}>
                        {gameObject?.checkboxes?.map((checkbox, index) => (
                            <label
                                key={index}
                                className={style.square_checkbox}
                            >
                                <input
                                    type="checkbox"
                                    checked={checkboxStatus[index as number]}
                                    onChange={() => buttonHandler(index)}
                                />
                                <span className={style.checkmark}></span>
                                {checkbox.text != null
                                    ? parser(
                                          checkbox.text[
                                              language as AcvtSupportedLanguages
                                          ]
                                      )
                                    : parser(
                                          checkbox.translations[
                                              language as AcvtSupportedLanguages
                                          ]
                                      )}
                            </label>
                        ))}
                    </div>

                    <div className={style.description}>
                        {parser(
                            gameObject?.description[
                                language as AcvtSupportedLanguages
                            ] ?? ''
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
